angular.module 'app'
.controller 'AdvisoryCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
